import store from '@store'

export function registerStoreModule (moduleName, storeModule) {
  if (!(store && store.state && store.state[moduleName]))
    store.registerModule(moduleName, storeModule)
}
